<template>
  <div :style="this.$store.state.style">
    <div class="wlcm-label" v-if="user">
      <span
        ><span style="display: var(--logout_display)">Welcome</span>
        <b class="wlcm-label-name">{{ getName() }}</b></span
      >
      <button v-on:click="logOutNotification()">
        <img
          v-bind:src="
            require('../../assets/images/' +
              this.$store.state.style['--logout_icon'])
          "
        />
        <span style="display: var(--logout_display)">Logout</span>
      </button>
      <!--<button v-on:click="renew()"><img src=""> renew</button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardWelcome",
  props: ["user"],
  methods: {
    logOutNotification() {
      let logOutConfirmed = confirm("Are you sure you want to logout?");
      if (logOutConfirmed) {
        this.$store.dispatch("logoutAction");
      }
    },
    renew() {
      this.$AuthService.silentRefresh();
    },
    getName(){
      let user = this.$props.user;
      let name = "";

      if(user.hasOwnProperty("first_name") && user.first_name != null && user.first_name.length > 0 && 
        user.hasOwnProperty("last_name") && user.last_name != null && user.last_name.length > 0 )
      {
        name = `${user.first_name[0]}${user.last_name[0]}`;
      }
      else{
        let nameArr = user.name.split(" ");
        if(nameArr.length == 1 )
          name= nameArr[0][0] ;
        if(nameArr.length > 1 )
          name= `${nameArr[0][0]}${nameArr[1][0]}` ;

      }
      return name.toUpperCase();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.wlcm-label {
  float: right;
  position: relative;
  font-size: 15px;
  line-height: 45px;
  color: var(--header_text_color);
  display: var(--wlcm_display);
  flex-direction: var(--wlcm_display_dir);
  /*position: absolute;*/
  /* right: 190px; */
}
.wlcm-label span {
  margin-right: 14px;
}
.wlcm-label .fa-chevron-down {
  font-size: 1rem;
  margin: 0 10px;
}
.wlcm-label button {
  border: 0;
  color: var(--header_text_color);
  font-size: 15px;
  float: right;
  line-height: 45px;
  font-weight: bold;
  padding: 0 14px;
  height: var(--logout_btn_height);
  background: transparent;
  border-left: var(--logout_btn_border_left);
  border-right: var(--logout_btn_border_right);
  margin-right: var(--logout_btn_margin_right);
}
.wlcm-label button img {
  float: left;
  margin: var(--wlcm_label_margin);
}
.wlcm-label-name {
  background: var(--wlcm_label_bg);
  border: var(--wlcm_label_border);
  height: 40px;
  width: 40px;
  display: var(--wlcm_label_display);
  border-radius: 50%;
  text-align: center;
  line-height: 38px;
}
</style>
